/* =============================================================
 * SicilyAddict - Sticky Add To Cart (solo mobile)
 * -------------------------------------------------------------
 * Non sostituisce il product form nativo di Warehouse: rispecchia
 * il suo stato e inoltra il click al pulsante originale, cosi'
 * varianti, quantita', disponibilita', sconti automatici e
 * Rebuy Smart Cart continuano a funzionare come prima.
 * ============================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-sa-sticky-atc]');
  if (!root) return;

  var form = document.querySelector('form.product-form[action*="/cart/add"]')
          || document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var nativeBtn = form.querySelector('.product-form__add-button');
  if (!nativeBtn) return;

  var elName  = root.querySelector('[data-sa-name]');
  var elMeta  = root.querySelector('[data-sa-meta]');
  var elPrice = root.querySelector('[data-sa-price]');
  var elBtn   = root.querySelector('[data-sa-btn]');
  var labels  = (window.languages || {});

  document.body.classList.add('sa-has-sticky-atc');

  /* ---------- formattazione prezzo ------------------------- */
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = (window.theme && window.theme.moneyFormat) || '&euro;{{amount_with_comma_separator}}';
    var value = cents / 100;
    function withComma(n) {
      return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    }
    function withPeriod(n) {
      return n.toFixed(2);
    }
    var out = fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(value))
      .replace(/\{\{\s*amount\s*\}\}/g, withPeriod(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withPeriod(value));
    /* il money format puo' contenere entita' HTML tipo &euro; */
    var tmp = document.createElement('textarea');
    tmp.innerHTML = out;
    return tmp.value.replace(/<[^>]*>/g, '').trim();
  }

  /* ---------- lettura stato dal DOM nativo ----------------- */
  function cleanText(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .visually-hidden--inline, [aria-hidden="true"]').forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function readPriceFromDom() {
    var node = document.querySelector('.product-meta .price-list .price--highlight')
            || document.querySelector('.product-meta .price-list .price')
            || document.querySelector('.product-form .price-list .price--highlight')
            || document.querySelector('.product-form .price-list .price');
    return cleanText(node);
  }

  function readVariantLabel() {
    var parts = [];
    form.querySelectorAll('.product-form__option-selector, .block-swatch-list, .variant-selector').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) {
        var lbl = checked.id ? group.querySelector('label[for="' + checked.id + '"]') : null;
        if (lbl) parts.push(cleanText(lbl));
        else if (checked.value) parts.push(String(checked.value).trim());
      }
    });
    form.querySelectorAll('select[name^="options"]').forEach(function (sel) {
      if (sel.value) parts.push(sel.value.trim());
    });
    return parts.filter(Boolean).join(' · ');
  }

  function syncAvailability() {
    var disabled = nativeBtn.hasAttribute('disabled') || nativeBtn.classList.contains('button--disabled');
    elBtn.disabled = disabled;
    elBtn.textContent = disabled
      ? (labels.productFormSoldOut || 'Non disponibile')
      : (labels.productFormAddToCart || 'Aggiungi al carrello');
  }

  function sync(variant) {
    if (variant && typeof variant.price === 'number') {
      elPrice.textContent = formatMoney(variant.price);
    } else {
      var dom = readPriceFromDom();
      if (dom) elPrice.textContent = dom;
    }

    var label = (variant && variant.title && variant.title !== 'Default Title')
      ? variant.title
      : readVariantLabel();

    if (label) {
      elMeta.textContent = label;
      elMeta.hidden = false;
    } else {
      elMeta.hidden = true;
    }

    syncAvailability();
  }

  /* ---------- eventi tema ---------------------------------- */
  document.addEventListener('variant:change', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    setTimeout(function () { sync(variant); }, 0);
  });

  form.addEventListener('change', function () { setTimeout(function () { sync(null); }, 80); });

  new MutationObserver(function () { syncAvailability(); })
    .observe(nativeBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });

  /* ---------- inoltro del click al form nativo -------------- */
  elBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (elBtn.disabled) return;
    nativeBtn.click();
  });

  /* ---------- visibilita' ----------------------------------- */
  var showing = false;
  function setVisible(v) {
    if (v === showing) return;
    showing = v;
    root.classList.toggle('is-visible', v);
  }

  var sentinel = form.querySelector('.product-form__buy-buttons') || nativeBtn;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastTop = entry.boundingClientRect.top < 0;
        setVisible(!entry.isIntersecting && pastTop);
      });
    }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });
    io.observe(sentinel);
  } else {
    window.addEventListener('scroll', function () {
      setVisible(sentinel.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  /* nasconde la barra quando il carrello o un popup e' aperto */
  ['rebuy:cart:open', 'cart:open', 'popup:open'].forEach(function (evt) {
    document.addEventListener(evt, function () { root.classList.add('sa-hide'); });
  });
  ['rebuy:cart:close', 'cart:close', 'popup:close'].forEach(function (evt) {
    document.addEventListener(evt, function () { root.classList.remove('sa-hide'); });
  });

  sync(null);
})();
